import type { MetaFunction } from 'react-router';

import { canonicalTag } from '@jane/bloom/resources/meta/canonicalTag';
import { description } from '@jane/bloom/resources/meta/description';
import { getRootLoaderData } from '@jane/bloom/resources/meta/getRootLoaderData';
import { parentMeta } from '@jane/bloom/resources/meta/parentMeta';
import { preloadImage } from '@jane/bloom/resources/meta/preloadImage';
import { title } from '@jane/bloom/resources/meta/title';
import type { loader } from '@jane/bloom/routes/_menu.$basename.($storeSlug).jane-gold._index/route';

export const DEFAULT_TITLE = `Shop Jane Gold products | {{ storeName }} Dispensary {{ storeCity }}, {{ storeStateAbbr }}`;

export const janeGoldRouteMeta: MetaFunction<typeof loader> = (args) => {
  const {
    menuUrl,
    metaProps: {
      fulfillmentMode,
      pinnedStoreCity,
      pinnedStoreName,
      pinnedStoreState,
      reservationMode,
    },
  } = getRootLoaderData(args);
  const data = args.loaderData;

  const aboveTheFoldImages = (data?.menuProductImgsAboveTheFold || [])
    .map((product) => product.imageSrcSet?.fallbackSrc)
    .filter((value, index, array) => array.indexOf(value) === index);

  return [
    title(
      `Shop Jane Gold products`,
      `${pinnedStoreName} Dispensary ${pinnedStoreCity}, ${pinnedStoreState}`
    ),
    description(
      `Visit ${pinnedStoreName} dispensary in ${pinnedStoreCity}, ${pinnedStoreState} and order ${fulfillmentMode} cannabis online products for ${reservationMode}. Browse our online dispensary menu for flower, edibles, vape and more.`
    ),
    canonicalTag(args.location, menuUrl),
    ...aboveTheFoldImages.map(preloadImage),
    ...parentMeta(args),
  ];
};
